<div style="display: flex; justify-content: center; align-items: center;">
  <h1>Custom Stock</h1>

  </div>
<div>
  <nz-table
    #stockCustomTable
    [nzData]="stockCustomList()"
    [nzFrontPagination]="false"
    [nzPageSize]="10"
    [nzLoading]="isLoading()"
    >
    <thead>
      <tr >
        <th nzWidth="150px">Stock Code</th>
        <th nzWidth="300px">Description</th>
        <th nzWidth="100px">Cost</th>
        <th nzWidth="100px">Price</th>
        <th nzWidth="15%"><button nz-button nzType="default" (click)="addNewItem(); $event.stopPropagation();">Add New</button></th>
      </tr>
    </thead>
    <tbody>
      @if (newItem() !== null) {
        <tr [formGroup]="form">
          <td>
            <nz-form-control>
              <input nz-input placeholder="Stock Code" [formControl]="form.controls.stockCode" />
            </nz-form-control>
          </td>
          <td>
            <nz-form-control>
              <input nz-input placeholder="Description" [formControl]="form.controls.description" />
            </nz-form-control>
          </td>
          <td>
            <nz-form-control>
              <input nz-input type="number" placeholder="Cost" [formControl]="form.controls.cost" />
            </nz-form-control>
          </td>
          <td>
            <nz-form-control>
              <input nz-input type="number" placeholder="Price" [formControl]="form.controls.price" />
            </nz-form-control>
          </td>
          <td>
            <button nz-button nzType="primary" (click)="saveItem()" [disabled]="form.invalid">Save</button>
            <button nz-button nzType="default" (click)="cancelEdit()">Cancel</button>
          </td>
        </tr>
      }
        @for ( item of stockCustomTable.data; track item.stockCustomId) {
            @if ( item == selectedItem()) {
              <tr [formGroup]="form" [ngClass]="{'selected-row': selectedItem() === item}">
                <td>
                  <nz-form-control>
                    <input nz-input type="text" [formControl]="form.controls.stockCode" />
                  </nz-form-control>
                </td>
                <td>
                  <nz-form-control>
                    <input nz-input type="text" [formControl]="form.controls.description" [readOnly]="item.stockCustomDefaultId === 0" />
                </nz-form-control>
                </td>
                <td>
                  <nz-form-control>
                    <input nz-input type="number" [formControl]="form.controls.cost" />
                  </nz-form-control>
                </td>
                <td>
                  <nz-form-control>
                    <input nz-input type="number" [formControl]="form.controls.price" />
                  </nz-form-control>
                </td>

                <td>
                    <button nz-button nzType="primary" (click)="saveItem()" [disabled]="form.invalid">Save</button>
                    @if (item.stockCustomDefaultId !== 0) {
                      <button nz-button nzType="primary" (click)="removeItem(item)" >Remove</button>
                    }
                    
                    <button nz-button nzType="default" (click)="cancelEdit()">Cancel</button>
                </td>
            </tr>
          } @else {
                <tr (click)="selectItem(item)" [ngClass]="{'selected-row': selectedItem() === item}" nz-tooltip="Click to edit item">
                <td>{{ item.stockCode }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.cost | number:'1.2-2' }}</td>
                <td>{{ item.price | number:'1.2-2' }}</td>
                <td>
                    <button nz-button nzType="default" (click)="selectItem(item); $event.stopPropagation();">Edit</button>
            </tr>
          }
        }
    </tbody>
  </nz-table>
</div>
